// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ajHqC","relative":"style_relative__CVU4z","playButtonClick":"style_playButtonClick__cmi1w","drible":"style_drible__rA3bq"};